module.exports = __webpack_public_path__ + "img/W-as3.ad1f4c73.jpg";